import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Timer from '../Timer/Timer';
import CallHandler from './CallHandler/CallHandler';

const CallHandlerContainer = ({
    call, 
    outgoingCall, 
    handleEndCall, 
    handleEndOutgoingCall, 
    callingNumber = '', 
    invitation,
    handleAcceptCall,
    handleRejectCall
}) => {

    const { t } = useTranslation(['softphone']);
    const [number, setNumber] = useState(callingNumber);
    const [from, setFrom] = useState('');
    
    const handleHangUp = () => {
        handleEndCall();
    };

    const handleHangUpOutgoing = () => {
        handleEndOutgoingCall();
    };

    useEffect(() => {
        if(call.data && Object.keys(call.data).length>0){
            setNumber(call.data.incomingInviteRequest.message.from.uri.normal.user);
        }
    }, [call]);

    useEffect(() => {
        setNumber(callingNumber);
    }, [callingNumber]);

    //invitations
    const handleReject = () => {
        handleRejectCall();
    }

    const handleAccept = () => {
        handleAcceptCall();
    }

    useEffect(() => {
      if(invitation && invitation.data && Object.keys(invitation.data).length){
        setFrom(invitation.data.incomingInviteRequest.message.from.uri.normal.user);
      }
    }, [invitation])

    return(
        <>
            { call.data &&
                <CallHandler 
                    number={number}
                    callState={
                        call.ended ?
                            t('softphone:ended_call')
                        :
                            <Timer />
                    }
                    showHungUpButton={!(call.ended)}
                    handleHangUp={handleHangUp}
                />
            }
            
            {
                outgoingCall.data && 
                <CallHandler 
                    number={number}
                    callState={ 
                                !(outgoingCall.accepted) && !(outgoingCall.ended) ? t('softphone:calling') 
                                : outgoingCall.accepted && !(outgoingCall.ended) ? t('softphone:on_call') 
                                : outgoingCall.ended ? t('softphone:ended_call') 
                                : ''
                            }
                    showHungUpButton={!(outgoingCall.ended) && outgoingCall.data}
                    handleHangUp={handleHangUpOutgoing}
                />
            }
            {
                ( invitation && invitation.thereIs && invitation.data && Object.keys(invitation.data).length>0 ) &&
                    <CallHandler 
                        number={from}
                        callState={ 
                            invitation.rejected ? t('softphone:rejected_call') : invitation.cancelled ? t('softphone:lost_call') : t('softphone:incoming_call')
                        }
                        showHungUpButton={!(invitation.rejected) && !(invitation.cancelled)}
                        showAcceptButton={!(invitation.rejected) && !(invitation.cancelled)}
                        handleAccept={handleAccept}
                        handleHangUp={handleReject}
                    />
            }
        </>
    )
};
export default CallHandlerContainer;